import { ArrowDown as ArrowDownIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "../../../components/ui/button/index.js";
import { cn } from "../../../lib/utils.js";

export function ScrollToLatestButton({
  formattedCount,
  onClick,
}: {
  formattedCount: string | null;
  onClick: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  const label =
    formattedCount == null
      ? t("inbox.thread.scrollToLatest")
      : t("inbox.thread.scrollToLatestWithCount", { count: formattedCount });

  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-3 z-10 flex justify-center">
      <Button
        type="button"
        variant="outline"
        size="sm"
        className={cn(
          "pointer-events-auto relative size-10 rounded-full border-line bg-surface-elevated p-0 text-ink shadow-sm",
          "hover:bg-surface-muted hover:text-ink",
          "focus-visible:shadow-[0_0_0_3px_color-mix(in_srgb,var(--color-accent)_35%,transparent)]",
        )}
        aria-label={label}
        onClick={onClick}
      >
        <ArrowDownIcon size={18} strokeWidth={2.25} className="rtl:rotate-0" aria-hidden="true" />
        {formattedCount ? (
          <span
            className="absolute -top-1.5 -end-1.5 inline-flex min-w-[1.125rem] justify-center rounded-full bg-accent px-1 py-px text-[0.65rem] font-semibold leading-4 text-accent-contrast tabular-nums [unicode-bidi:isolate]"
            dir="ltr"
          >
            {formattedCount}
          </span>
        ) : null}
      </Button>
    </div>
  );
}
